import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import TerminalView from "@tmu/components/terminal"

const Terminal = () => <TerminalView />

export default injectIntl(Terminal)
